import React from 'react'
import classnames from 'classnames'
import { Icon } from '../../icon'
import styles from './user-avatar.module.scss'
import { UserContext } from '../../../types'

interface Props {
  user: UserContext | null
  badge?: boolean
}

export const UserAvatar: React.FC<Props> = ({ user, badge }) => {
  return (
    <div
      className={classnames(styles.container, {
        [styles.badge]: badge
      })}
    >
      {(user && user.profilePictureUrl && (
        <img
          alt="User Profile"
          className={styles.image}
          src={user.profilePictureUrl}
        />
      )) || (
        <div className={styles.icon}>
          <Icon name="user" />
        </div>
      )}
    </div>
  )
}
